var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicensionLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79166 11.4583H14.2083M7.79166 14.2083H11.4583",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.916667,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04166 5.40825C5.04166 4.63825 5.04166 4.25325 5.19107 3.959C5.32294 3.70005 5.53345 3.48953 5.79241 3.35767C6.08574 3.20825 6.47074 3.20825 7.24166 3.20825H11.4638C11.8002 3.20825 11.968 3.20825 12.1266 3.24584C12.2684 3.28006 12.4007 3.33506 12.5235 3.41084C12.6628 3.49609 12.7811 3.61525 13.0185 3.85267L16.3139 7.14717C16.5522 7.3855 16.6714 7.50467 16.7557 7.64217C16.8315 7.76684 16.8865 7.89945 16.9207 8.04C16.9583 8.19859 16.9583 8.36634 16.9583 8.70275V16.5916C16.9583 17.3616 16.9583 17.7466 16.8089 18.0408C16.677 18.2998 16.4665 18.5103 16.2076 18.6422C15.9142 18.7916 15.5292 18.7916 14.7583 18.7916H7.24166C6.47166 18.7916 6.08666 18.7916 5.79241 18.6422C5.53345 18.5103 5.32294 18.2998 5.19107 18.0408C5.04166 17.7475 5.04166 17.3625 5.04166 16.5916V5.40825Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.916667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 3.20825V6.50825C11.4583 7.27825 11.4583 7.66325 11.6086 7.9575C11.7403 8.21631 11.9505 8.42681 12.2091 8.55884C12.5024 8.70825 12.8874 8.70825 13.6583 8.70825H16.9583",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.916667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensionLogo);
export default __webpack_public_path__ + "static/media/licension-logo.c34d1ee87088b486f4f38a1c73de56db.svg";
export { ForwardRef as ReactComponent };